export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function matchesAllKeywords(fields: string[], keywords: string[]): boolean {
  const haystack = fields.join(" ").toLowerCase();
  return keywords.every((keyword) => haystack.includes(keyword));
}

export function highlightKeywords(
  text: string,
  keywords: string[],
  hitClass = "search-hit"
): string {
  const source = text || "";
  if (!keywords.length) {
    return escapeHtml(source);
  }
  const matches: Array<{ start: number; end: number }> = [];
  keywords.forEach((keyword) => {
    const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const reg = new RegExp(escapedKeyword, "gi");
    let match: RegExpExecArray | null = reg.exec(source);
    while (match) {
      matches.push({
        start: match.index,
        end: match.index + match[0].length,
      });
      if (match[0].length === 0) {
        reg.lastIndex += 1;
      }
      match = reg.exec(source);
    }
  });
  if (!matches.length) {
    return escapeHtml(source);
  }
  matches.sort((a, b) => a.start - b.start || b.end - a.end);
  const merged: typeof matches = [];
  matches.forEach((match) => {
    const last = merged[merged.length - 1];
    if (!last || match.start >= last.end) {
      merged.push(match);
    }
  });
  let result = "";
  let lastIndex = 0;
  merged.forEach((match) => {
    result += escapeHtml(source.slice(lastIndex, match.start));
    result += `<em class="${hitClass}">${escapeHtml(
      source.slice(match.start, match.end)
    )}</em>`;
    lastIndex = match.end;
  });
  result += escapeHtml(source.slice(lastIndex));
  return result;
}
